import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import { COLOR_TO_ANNOT } from "../../constants/Constants";
import { handleToShowShadowAndStroke, setFileColorByFill } from "./MarkupFunction";

const ColorDropdown = ({ isARMarkup }) => {
    const localisedValues = useLanguageChange();
    const { selectedColorIndex, isShadowOrStroke } = useSelector((state) => state.markup);
    const handleToCloseColorPalate = () => {
        document.getElementById("colorfill")?.classList.remove("show");
        document.getElementById("color-picker-dropdown")?.classList.remove("show");
    };
    const colorPalate = COLOR_TO_ANNOT.map((color, i) => (
        <div className='color-radiobox-out' key={color}>
            <div className='color-radiobox'>
                <label className={`color-picker-${i + 1}`}>
                    <input type='radio' value={i} name='colorpickerFile' onClick={(e) => setFileColorByFill(e)} />
                    <span className='for-design'></span>
                </label>
            </div>
        </div>
    ));

    return (
        <div className='markup-menu-item' data-testid='markup-edit-menu-bar'>
            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                <div className='color-picker-box dropdown'>
                    <button
                        className='btn dropdown-toggle triangle-none'
                        type='button'
                        id='colorfill'
                        data-bs-toggle='dropdown'
                        aria-expanded='false'
                    >
                        <span className={`fill-selected-color color-picker-${+selectedColorIndex + 1}`}></span>
                        <span className='moremenu-text'>{localisedValues?.color_label}</span>
                    </button>
                    <div
                        className='dropdown-menu color-picker'
                        id='color-picker-dropdown'
                        aria-labelledby='colorfill'
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={() => {}}
                    >
                        <div className='color-picker-head'>
                            <div className='color-picker-head-left'>
                                {!isARMarkup && (
                                    <div className='checkbox'>
                                        <label>
                                            <input
                                                type='checkbox'
                                                id='colorpickerStrokeCheckbox'
                                                checked={isShadowOrStroke}
                                                onChange={(e) => handleToShowShadowAndStroke(e)}
                                            />
                                            <span className='for-design'></span>
                                            <span className='for-text'>{localisedValues?.add_shadow_and_stroke}</span>
                                        </label>
                                    </div>
                                )}
                            </div>
                            <div className='close-color-picker'>
                                <button type='button' className='btn' id='color-picker-close-button' onClick={handleToCloseColorPalate}>
                                    <span className='btn-icon icon-close-light'></span>
                                </button>
                            </div>
                        </div>
                        <div className='color-picker-body'>
                            <div className='color-picker-list'>{colorPalate}</div>
                        </div>
                    </div>
                </div>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{localisedValues?.color_label}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

ColorDropdown.propTypes = {
    isARMarkup: PropTypes.bool,
};

export default ColorDropdown;
